import { useEffect, useState } from "react";
import api from "@/lib/api";
import { ImageOff } from "lucide-react";

export default function PhotoImage({ photoId, alt = "", className = "", testId }) {
  const [src, setSrc] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let url;
    let cancelled = false;
    api.get(`/photos/${photoId}/file`, { responseType: "blob" })
      .then((res) => {
        if (cancelled) return;
        url = URL.createObjectURL(res.data);
        setSrc(url);
      })
      .catch(() => !cancelled && setError(true));
    return () => { cancelled = true; if (url) URL.revokeObjectURL(url); };
  }, [photoId]);

  if (error) {
    return (
      <div className={`flex items-center justify-center bg-muted ${className}`} data-testid={testId}>
        <ImageOff className="h-6 w-6 text-muted-foreground" />
      </div>
    );
  }
  if (!src) {
    return <div className={`animate-pulse bg-muted ${className}`} data-testid={testId} />;
  }
  return <img src={src} alt={alt} className={className} data-testid={testId} loading="lazy" />;
}
